import React from 'react';

const DestinationBar = ({ destinations, onSelectDestination, selectedId }) => (
  <div
    className="
      flex flex-col space-y-1 overflow-y-auto
      max-h-[88px]    // ~2 items (2*44px) on xs
      sm:max-h-[176px] // ~4 items on sm
      md:max-h-[264px] // ~6 items on md
      lg:max-h-[352px] // ~8 items on lg
      xl:max-h-[440px] // ~10 items on xl
    "
  >
    {destinations.map(dest => (
      <button
        key={dest.id}
        onClick={() => onSelectDestination(dest.id)}
        className={`
          w-full text-left px-4 py-2 
          rounded transition-colors
          hover:bg-orange-50
          ${dest.id === selectedId ? 'bg-orange-100' : 'bg-white'}
        `}
      >
        <span className="text-sm">{dest.name}</span>
      </button>
    ))}
  </div>
);

export default DestinationBar;
